import * as bootstrap from "bootstrap";

if (document.URL.match("/applies/thanks")) {
  document.addEventListener("DOMContentLoaded", () => {
    window.setTimeout(() => {
      const applyThanksModal = new bootstrap.Modal(
        document.getElementById("applyThanksModal")
      );

      const showAlert = () => {
        applyThanksModal.show();
      };

      showAlert();
    }, 2000);
  });
}
